/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

/**
 * Permission role for the resource (owner > writer > reader)
 */
export const ResourceRole = {
  Owner: "owner",
  Writer: "writer",
  Reader: "reader",
} as const;
/**
 * Permission role for the resource (owner > writer > reader)
 */
export type ResourceRole = ClosedEnum<typeof ResourceRole>;

/** @internal */
export const ResourceRole$inboundSchema: z.ZodNativeEnum<typeof ResourceRole> =
  z.nativeEnum(ResourceRole);
/** @internal */
export const ResourceRole$outboundSchema: z.ZodNativeEnum<typeof ResourceRole> =
  ResourceRole$inboundSchema;
